import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BasketReturnModel, LineItemReturnModel } from 'src/business/services/client.generated';
import { SourceSet } from 'src/core-lib/umbraco/umbraco-image.model';
import { ImageUtil } from 'src/layout/media/image.util';
import { debounce } from 'src/utils/debounce';
import { BasketService } from '../../services/basket.service';

@Component({
    selector: 'app-basket-line',
    templateUrl: './basket-line.component.html',
    styleUrls: ['./basket-line.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketLineComponent implements OnInit {
    image: string;
    srcset: SourceSet[];

    @Input()
    line: LineItemReturnModel;
    @Input()
    addons: LineItemReturnModel[];
    @Input()
    basket: BasketReturnModel;
    removeDebounced: (...args: any[]) => void;

    constructor(private basketService: BasketService) {
        this.removeDebounced = debounce(() => this.basketService.deleteLine([this.line.id, ...(this.addons || []).map(addon => addon.id)]));
    }

    ngOnInit(): void {
        this.srcset = ImageUtil.productCardSrcset(this.line.imageUrl);
        this.image = this.srcset[this.srcset.length -1]?.srcset?.href;
    }

    remove() {
        this.removeDebounced();
        return false;
    }


}
